<template>
  <div
    class="container"
    :class="containerClasses"
  >
    <v-row
      class="layout-content no-gutters"
    >
      <transition name="fade">
        <router-view />
      </transition>
    </v-row>
  </div>
</template>

<script>
export default {
  name: 'LayoutContent',
  data() {
    return {
      isSidebarMini: false,
      expandContainer: false,
    };
  },
  computed: {
    containerClasses() {
      return {
        'container--expanded': this.expandContainer,
      };
    },
  },
  methods: {
    sideBarChanged({ mini }) {
      this.expandContainer = !mini;
    },
  },
};
</script>

<style lang="scss" scoped>
  .fade-enter-active,
  .fade-leave-active {
    transition-duration: 0.2s;
    transition-property: opacity;
    transition-timing-function: ease-in-out;
  }

  .fade-enter,
  .fade-leave-active {
    opacity: 0;
  }

  .container {
    width: 100vw;
    max-width: 100vw;
    margin: 0;
    padding: 0;
    -webkit-transition: padding 0.2s cubic-bezier(0.4, 0, 0.2, 1);
    -moz-transition: padding 0.2s cubic-bezier(0.4, 0, 0.2, 1);
    -o-transition: padding 0.2s cubic-bezier(0.4, 0, 0.2, 1);
    transition: padding 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  }

  .container--expanded {
    padding-left: 253px;
  }
</style>
